import { gql } from "@apollo/client";

export const SCREEN_GET_PROFILE_DATA = gql`
  query ScreenGetProfileData($currency: String) @client {
    wallet: getWallet(currency: $currency) {
      balanceIncludingPendingInFiat {
        currency
        value
      }
      balanceNotIncludingFrozen {
        btc {
          value
        }
      }
      transactions {
        id
      }
    }
    linkedCards: getLinkedCards {
      id
      brand
      expMonth
      expYear
      externalId
      last4
    }
  }
`;
